import config from '@/config'
import HttpClient from '@/api/http/client'
import ResponseError from '@/api/http/ResponseError'
import windowStore from '@/store/modules/window.store'

const http = new HttpClient(config.peanutbutterBaseUrl)

const AuthenticationPlatform = {
  PLAYPHONE: 'PLAYPHONE',
  EMAIL: 'EMAIL',
  FACEBOOK: 'FACEBOOK',
  APPLE: 'APPLE'
}

export { AuthenticationPlatform }

export default {
  install() {
    return http.post('/api/v1/unauthenticated/install', {}, true)
  },
  async refreshToken() {
    const response = await http.get('/api/v1/authenticated/refresh', true)

    if (!response.ok) {
      throw new Error('Failed to refresh token.')
    }
  },
  async signUp(credentials, extraInfo, authenticationPlatform, recaptchaToken, privacyPreferences) {
    extraInfo.emailLanguage = windowStore.state.language

    const response = await http.post('/api/v1/unauthenticated/signup', {
      authenticationPlatform,
      recaptchaToken,
      credentials,
      extraInfo,
      privacyPreferences
    }, true)

    if (response.ok) {
      return
    }

    throw new ResponseError(response.status)
  },
  async signIn(credentials, authenticationPlatform, recaptchaToken) {
    const response = await http.post('/api/v1/unauthenticated/signin', {
      authenticationPlatform,
      recaptchaToken,
      credentials
    }, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async requestPasswordReset(email, recaptchaToken) {
    const response = await http.post('/api/v1/unauthenticated/password/forgot', {
      email,
      recaptchaToken,
      language: windowStore.state.language
    }, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async resetPassword(newPassword, token) {
    const response = await http.post('/api/v1/unauthenticated/password/reset', { newPassword, token }, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  verifyProfile() {
    return http.get('/api/v1/authenticated/profile/verify', true).then(data => data.json())
  },
  async signOut() {
    const response = await http.get('/api/v1/authenticated/signout', true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  emitPlayVideo(timeUsage, segmentId, videoId) {
    return http.post('/api/v1/unauthenticated/play-video', {
      videoId: videoId.toString(),
      segmentId,
      timeUsage,
      contentTree: 'us'
    }, true)
  },
  async registerVindiSubscription(email, skuId, coupon, card, billing) {
    const response = await http.post(`/api/v1/authenticated/subscribe/vindi`, {
      email,
      card,
      billing,
      coupon,
      plan: skuId,
      media: { utmContent: 'direct' }
    }, true)

    let body = null
    try { body = await response.json() } catch {}

    if (!response.ok) {
      throw new ResponseError(response.status, body)
    }

    return body
  },
  async changeEmail(email, password, extraInfo) {
    const response = await http.post('/api/v1/authenticated/account/change-email', { email, password, extraInfo }, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async changePassword(oldPassword, newPassword) {
    const response = await http.post('/api/v1/authenticated/account/change-password', { oldPassword, newPassword }, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async cancelSubscription(subscriptionId) {
    const response = await http.post('/api/v1/authenticated/subscription/cancel', { subscriptionId }, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async createChildProfile(childProfile) {
    const response = await http.post('/api/v1/authenticated/children/profiles', childProfile, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async updateChildProfile(id, childProfile) {
    const response = await http.put(`/api/v1/authenticated/children/profiles/${id}`, childProfile, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async removeChildProfile(id) {
    const response = await http.delete(`/api/v1/authenticated/children/profiles/${id}`, true)

    if (!response.ok) {
      throw new ResponseError(response.status)
    }
  },
  async getAllChildrenProfiles() {
    return http.get('/api/v1/authenticated/children/profiles', true)
  }
}
